export default __webpack_public_path__ + "static/media/alert-publication.904d72f1.svg";